import { render } from "./x2y2.svg?vue&type=template&id=ada5787c"
const script = {}
script.render = render

export default script